/**
 * Composable for loading FontAwesome CSS only when needed
 */
let fontAwesomeLoaded = false

export function useFontAwesome() {
  const loadFontAwesome = async () => {
    if (!fontAwesomeLoaded) {
      await import('@fortawesome/fontawesome-free/css/all.css')
      fontAwesomeLoaded = true
    }
  }

  return {
    loadFontAwesome
  }
}